import { FC, useMemo } from "react"
import { Button, ButtonProps, useTheme } from "@mui/material"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"
import { ArrowLeftIcon } from "components/icons"

interface IBackButtonProps extends ButtonProps {
  label?: string
}

export const BackButton: FC<IBackButtonProps> = ({
  label = "back",
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const backIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon) || <ArrowLeftIcon />,
    [theme]
  )

  return (
    <Button variant="contained" startIcon={backIcon} {...props}>
      {t(label)}
    </Button>
  )
}
